import Team from './Team'

const TeamList = ({ teams }) => {
    
    const best_offset = Math.max(...teams.map(t => t.offset))

    function compare( a, b ) {
        if ( a.offset < b.offset ){
          return 1;
        }
        if ( a.offset > b.offset ){
          return -1;
        }
        return 0;
      }

    const sorted_teams = teams.sort(compare)
  
    return (
        <div>
            <h2>Ilmoittautuneet joukkueet</h2>

            <table>
            <tr>
                <th>Joukkueen nimi</th>
                <th>Osuus 1</th>
                <th>Osuus 2</th>
                <th>Osuus 3</th>
                <th>Lähtöaika</th>
                <th>Ero</th>
            </tr>
            {sorted_teams.map(t =>
                <Team
                team={t}
                boffset = {best_offset}
                />
            )}
            </table>
        </div>
    )
  }
  
  export default TeamList